'use client'

import React, { FC } from 'react'
import Image from 'next/image'
import { Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import { IBannersData, IFetchedDataRoot } from '@/types'

const TargetBanner: FC<IFetchedDataRoot<IBannersData>> = ({ results }) => {
  return (
    <Swiper
      modules={[Navigation]}
      breakpoints={{
        428: { slidesPerView: 1 },
        640: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 2.5,
        },
      }}
      spaceBetween={24}
      className="container mx-auto overflow-visible"
      navigation={{ prevEl: '.btn-prev-target', nextEl: '.btn-next-target' }}
    >
      {results.map(({ image, id, title }) => (
        <SwiperSlide key={'target-banner-' + id}>
          <div className="h-[350px] overflow-hidden rounded-xl">
            <Image
              src={image}
              alt={'target image ' + title}
              width={456}
              height={350}
              className="h-full w-full object-cover"
            />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  )
}

export default TargetBanner
